import routerOptions0 from "/var/www/sites/auth.ultrafedt.dk/releases/20251107195032/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export default {
...configRouterOptions,
...routerOptions0,
}